export default {
  '--theme-primary-color': 'var(--token-color-blue100)',
  '--theme-switcher-color': 'var(--token-color-blue200)',
  '--theme-sidebar-hover-color': 'var(--token-color-blue20)',
  '--theme-sidebar-active-color': 'var(--token-color-white)',
  '--theme-sidebar-child-color': 'var(--token-color-blue80)',
  '--theme-sidebar-text-color': 'var(--token-color-white)',
  '--theme-sidebar-text-active-color': 'var(--token-color-blue100)',
  '--theme-sidebar-highlight-color': 'var(--token-color-white)',
  '--theme-banner-color': 'var(--token-color-yellow100)',
};
